import { FinancialStatementAccount } from './FinancialStatementAccount';
import { FinancialStatementItem } from './FinancialStatementItem';
import { FinancialStatementPart } from './FinancialStatementPart';
import { GeneralLedgerTransaction } from './GeneralLedgerTransaction';
import { FsSums } from '../../utils/common/FsSums';
import { InvestorCapitalAccount } from '../capital-account/InvestorCapitalAccount';
import { SortService } from 'src/app/domain/company/service/sort.service';

export class FinancialStatement {
  uuid?: string;
  period?: Date;
  ownershipUuid?: string;
  lastGlUpload?: string;
  isCompleted?: boolean;
  gl: GeneralLedgerTransaction[];
  tb?: FinancialStatementAccount[];
  items?: FinancialStatementItem[];
  investors?: InvestorCapitalAccount[];
  // below properties are not saved in backend
  balanceSheetParts?: FinancialStatementPart[];
  profitLossParts?: FinancialStatementPart[];
  balanceSheetNetTotals = new FsSums();
  profitLossNetTotals = new FsSums();
  quarterlyGl: Map<string, GeneralLedgerTransaction[]>;

  constructor(gl: GeneralLedgerTransaction[], uuid?: string, period?: Date, ownershipUuid?: string, lastGlUpload?: string,
    isCompleted?: boolean, tb?: FinancialStatementAccount[], items?: FinancialStatementItem[], investors?: InvestorCapitalAccount[]) {
    this.uuid = uuid;
    this.period = period;
    this.ownershipUuid = ownershipUuid;
    this.lastGlUpload = lastGlUpload;
    this.isCompleted = isCompleted;
    this.gl = gl;
    this.tb = tb;
    this.items = items;
    this.investors = investors;
  }

  makeCopy(): FinancialStatement {
    return new FinancialStatement(
      this.gl,
      '',
      this.period,
      this.ownershipUuid,
      this.lastGlUpload,
      this.isCompleted,
      this.tb,
      this.items,
      this.investors,
    );
  }

  setQuarterlyGl(): void {
    const quarterlyGl = new Map<string, GeneralLedgerTransaction[]>();
    this.tb.forEach((account) => {
      account.quarterlyTransactionsMap.forEach((transactions, quarter) => {
        if (quarterlyGl.has(quarter)) {
          quarterlyGl.set(quarter, quarterlyGl.get(quarter).concat(transactions));
        } else {
          quarterlyGl.set(quarter, transactions);
        }
      });
    });
    this.quarterlyGl = SortService.sortGlMap(quarterlyGl);
  }

}
